import type { Calculations } from '@features/glossary';
import { layout } from '@features/lci-report/domain/dimensions';
import { themeV2 } from '@features/lci-report/domain/theme-v2';
import { MASTER_NAMES } from '@features/lci-report/utils/shared-presentation-config-v2';
import { contentSlideHeaderV2 } from '@features/lci-report/utils/slide-header-v2';
import type { Slide } from '@features/powerpoint';
import { getColumnXPositions } from '@features/powerpoint';
import type { SlideSection } from '../domain/content';
import { getCalculationsV2 } from '../domain/content-v2';
import { columnV2 } from './column-v2';

type PageV2Props = {
  title: string;
};

export const pageV2 = (
  calculations: Calculations,
  pageNumber: number,
  entriesPerColumnPerPage: number[],
  props: PageV2Props
): Slide => {
  const sections: SlideSection[] = Object.values(calculations).map(
    (section, sectionIndex) => ({
      label: section.label,
      items: getCalculationsV2(section.items, {
        perPage: entriesPerColumnPerPage[sectionIndex] ?? 0,
        page: pageNumber,
      }),
    })
  );

  const columnPositions = getColumnXPositions(
    0.33,
    layout.width - 2 * 0.33,
    sections.length,
    0.5
  );

  const sectionsWithContent = sections.filter(
    section => section.items.text.length > 0
  );

  const columns = sectionsWithContent.map((section, columnIndex) =>
    columnV2(section, {
      x: columnPositions.positions[columnIndex],
      y: 1.15,
      h: 5.5,
      w: columnPositions.columnWidth,
    })
  );

  return {
    slideMaster: MASTER_NAMES.titleAndContent,
    texts: [
      contentSlideHeaderV2(props.title, { color: themeV2.colors.metricBlue }),
      ...columns,
    ],
  };
};
